<template>
  <div v-loading="loading">
    <FormBox
      :title="$t('hzmbChange.title.drivers_data')"
      style="background: #fff"
    >
      <span class="title-tips">{{
        $t("hzmbChange.title.drivers_data_tips")
      }}</span>
      <div v-if="applicantType === 'PERSON'" class="input_choose">
        <div class="input_choose_title">
          {{ $t("hzmbChange.message.input_drivers") }}
        </div>
        <div class="input_choose_btns">
          <el-radio-group v-model="setDriver" @change="quotaChange">
            <el-radio v-if="quotaPersonAge >= 70" :label="0" border>{{
              $t("hzmbChange.message.notUsed")
            }}</el-radio>
            <el-radio
              v-for="(item, index) in [{}]"
              :key="index"
              :label="index + 1"
              border
              >{{ driversNum(index, false) }}</el-radio
            >
          </el-radio-group>
        </div>
      </div>
      <div v-for="(item, index) in form.drivers" :key="index">
        <FormCard
          :title="driversNum(index, false)"
          @close="closeCard(index)"
          :showClose="form.drivers.length != 1"
        >
          <el-form
            ref="ruleForm"
            :model="form.drivers[index]"
            class="form_box"
            :rules="driversRules"
            hide-required-asterisk
          >
            <el-row :gutter="86" type="flex">
              <el-col :xs="24" :sm="12">
                <el-form-item
                  :label="
                    $t('hzmbChange.label.driver_nameCn', [numLetter(index)])
                  "
                  prop="drvCname"
                >
                  <el-input
                    v-model="form.drivers[index].drvCname"
                    :placeholder="
                      locked == index + 1
                        ? ''
                        : $t('hzmbChange.message.driver_nameCn_plh')
                    "
                    :disabled="locked == index + 1"
                    @input="inputToUpperCase($event, index, 'drvCname')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-form-item
                  :label="
                    $t('hzmbChange.label.driver_nameEn', [numLetter(index)])
                  "
                  prop="drvEname"
                >
                  <el-input
                    v-model="form.drivers[index].drvEname"
                    :placeholder="
                      locked == index + 1
                        ? ''
                        : $t('hzmbChange.message.driver_nameEn_plh')
                    "
                    :disabled="locked == index + 1"
                    @input="inputToUpperCase($event, index, 'drvEname')"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-form-item
                  :label="
                    isE02F02
                      ? $t('hzmbChange.label.hk_drvIdentNo', [numLetter(index)])
                      : $t('hzmbChange.label.driver_identityNo', [
                          numLetter(index),
                        ])
                  "
                  prop="drvIdentNo"
                  :disabled="locked == index + 1"
                >
                  <el-input
                    v-model.trim="form.drivers[index].drvIdentNo"
                    :placeholder="
                      locked == index + 1
                        ? ''
                        : isE02F02
                        ? $t('hzmbChange.message.hk_drvIdentNo')
                        : $t('hzmbChange.message.driver_identityNo_plh')
                    "
                    :disabled="locked == index + 1"
                    :maxlength="8"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-form-item
                  :label="
                    $t('hzmbChange.label.driver_birthday', [numLetter(index)])
                  "
                  prop="drvBirthDate"
                >
                  <el-date-picker
                    v-model="form.drivers[index].drvBirthDate"
                    type="date"
                    :placeholder="
                      locked == index + 1
                        ? ''
                        : $t('hzmbChange.message.driver_birthday_plh')
                    "
                    :picker-options="beforeToday"
                    format="dd/MM/yyyy"
                    value-format="yyyy-MM-dd"
                    :disabled="locked == index + 1"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-form-item
                  :label="$t('hzmbChange.label.driver_sex', [numLetter(index)])"
                  prop="drvGender"
                >
                  <el-select
                    v-model="form.drivers[index].drvGender"
                    :placeholder="$t('hzmbChange.message.driver_sex_plh')"
                    value-key="codeKey"
                  >
                    <el-option
                      v-for="item in sex"
                      :key="item.codeKey"
                      :label="item[`${$t('message.codeName')}`]"
                      :value="item.codeKey"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-form-item
                  :label="
                    $t('hzmbChange.label.driver_nationality', [
                      numLetter(index),
                    ])
                  "
                  prop="drvNational"
                >
                  <el-select
                    v-model="form.drivers[index].drvNational"
                    value-key="codeKey"
                    filterable
                    :placeholder="
                      $t('hzmbChange.message.driver_nationality_plh')
                    "
                    @change="changeNationality($event, index)"
                  >
                    <el-option
                      v-for="nation in nationality"
                      :key="nation.codeKey"
                      :label="nation[`${$t('message.codeName')}`]"
                      :value="nation.codeKey"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <template v-if="form.drivers[index].otherNationality">
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="
                      $t('hzmbChange.label.driver_other_nationality', [
                        numLetter(index),
                      ])
                    "
                    prop="otherNationalityText"
                  >
                    <el-input
                      v-model="form.drivers[index].otherNationalityText"
                      :placeholder="
                        $t('hzmbChange.message.driver_other_nationality_plh')
                      "
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12"> </el-col>
              </template>
              <el-col v-if="form.hzmbSubtype !== 'E02'" :xs="24" :sm="12">
                <el-form-item
                  :label="
                    $t('hzmbChange.label.driver_macauDrivingLicenseType', [
                      numLetter(index),
                    ])
                  "
                  prop="drvLicTypeMo"
                >
                  <el-select
                    filterable
                    v-model="form.drivers[index].drvLicTypeMo"
                    :placeholder="
                      $t(
                        'hzmbChange.message.driver_macauDrivingLicenseType_plh'
                      )
                    "
                    value-key="codeKey"
                  >
                    <el-option
                      v-for="item in drivingLicenseType"
                      :key="item.codeKey"
                      :label="item[`${$t('message.codeName')}`]"
                      :value="item.codeKey"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col v-if="form.hzmbSubtype !== 'E02'" :xs="24" :sm="12">
                <el-form-item
                  :label="
                    $t('hzmbChange.label.driver_macauDrivingLicenseNo', [
                      numLetter(index),
                    ])
                  "
                  prop="drvLicNoMo"
                >
                  <el-input
                    v-model.trim="form.drivers[index].drvLicNoMo"
                    :placeholder="
                      $t('hzmbChange.message.driver_macauDrivingLicenseNo_plh')
                    "
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-form-item
                  v-if="isE02F02"
                  :label="$t('hzmbChange.label.drvMobile', [numLetter(index)])"
                  prop="drvMobile"
                  :rules="[
                    {
                      required: true,
                      message: $t('hzmbChange.message.notNull'),
                    },
                    {
                      pattern:
                        form.drivers[index].mobileAreaCode === '853'
                          ? /^[6]{1}[0-9]{7}$/
                          : /^[0-9]{8}$/,
                      message: $t('hzmbChange.message.macauMobile'),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <div class="m-mobile_row">
                    <el-select
                      v-model="form.drivers[index].mobileAreaCode"
                      :placeholder="$t('hzmbG.label.mobileAreaCode')"
                    >
                      <el-option
                        v-for="item in areas"
                        :key="item.value"
                        :value="item.value"
                        :label="item.text"
                      ></el-option>
                    </el-select>
                    <el-input
                      v-model="form.drivers[index].drvMobile"
                      :placeholder="$t('hzmbChange.message.drvMobile')"
                      maxlength="8"
                    >
                    </el-input>
                  </div>
                </el-form-item>
                <el-form-item
                  v-else
                  :label="
                    $t('hzmbChange.label.driver_macauMobile', [
                      numLetter(index),
                    ])
                  "
                  prop="drvMobile"
                >
                  <el-input
                    v-model="form.drivers[index].drvMobile"
                    :placeholder="
                      locked == index + 1
                        ? ''
                        : $t('hzmbChange.message.macauMobile_plh')
                    "
                    :disabled="locked == index + 1"
                    maxlength="8"
                  >
                    <template slot="prepend">+853</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  :label="
                    isE02F02
                      ? $t('hzmbChange.label.drvAddress', [numLetter(index)])
                      : $t('hzmbChange.label.driver_macauAddress', [
                          numLetter(index),
                        ])
                  "
                  prop="drvAddress1"
                >
                  <el-input
                    v-model="form.drivers[index].drvAddress1"
                    :placeholder="
                      locked == index + 1
                        ? ''
                        : isE02F02
                        ? $t('hzmbChange.message.drvAddress')
                        : $t('hzmbChange.message.macauAddress_plh')
                    "
                    :disabled="locked == index + 1"
                    @focus="onAddressFocus(index)"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-form-item
                  :label="
                    $t('hzmbChange.label.driver_mainlandPhone', [
                      numLetter(index),
                    ])
                  "
                  prop="mainlandPhone"
                >
                  <el-input
                    v-model="form.drivers[index].mainlandPhone"
                    :placeholder="
                      locked == index + 1
                        ? ''
                        : $t('hzmbChange.message.driver_mainlandPhone_plh')
                    "
                    :disabled="locked == index + 1"
                    maxlength="11"
                  >
                    <template slot="prepend">+86</template>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12">
                <el-form-item
                  :label="
                    $t('hzmbChange.label.driver_mainlandEmail', [
                      numLetter(index),
                    ])
                  "
                  prop="mainlandEmail"
                >
                  <el-input
                    v-model="form.drivers[index].mainlandEmail"
                    :placeholder="
                      locked == index + 1
                        ? ''
                        : $t('hzmbChange.message.driver_mainlandEmail_plh')
                    "
                    :disabled="locked == index + 1"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="24">
                <div :class="`tips_red tips_red_${$i18n.locale}`">
                  {{
                    $t(
                      "message.formRuleMessage.either_or_mainlandPhone_mainlandEmail_drivers"
                    )
                  }}
                </div>
              </el-col>
              <el-col v-if="!isE02F02" :xs="24" :sm="12">
                <el-form-item
                  :label="
                    $t('hzmbChange.label.driver_mainlandDrivingLicenseNo', [
                      numLetter(index),
                    ])
                  "
                  prop="drvLicNoCn"
                  :rules="[
                    {
                      max: 20,
                      message: $t('hzmbChange.message.maxLength', [20]),
                    },
                    {
                      required: isAfterYears(
                        form.drivers[index].drvBirthDate,
                        70
                      ),
                      message: $t('hzmbChange.message.notNull'),
                    },
                  ]"
                >
                  <el-input
                    v-model="form.drivers[index].drvLicNoCn"
                    :placeholder="
                      $t(
                        'hzmbChange.message.driver_mainlandDrivingLicenseNo_plh'
                      )
                    "
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col v-if="!isE02F02" :xs="24" :sm="12">
                <el-form-item
                  :label="
                    $t('hzmbChange.label.driver_mainlandDrivingPermitNo', [
                      numLetter(index),
                    ])
                  "
                  prop="drvCnFileNo"
                  :rules="[
                    {
                      max: 20,
                      message: $t('hzmbChange.message.maxLength', [20]),
                    },
                    {
                      required: isAfterYears(
                        form.drivers[index].drvBirthDate,
                        70
                      ),
                      message: $t('hzmbChange.message.notNull'),
                    },
                  ]"
                >
                  <el-input
                    v-model="form.drivers[index].drvCnFileNo"
                    :placeholder="
                      $t(
                        'hzmbChange.message.driver_mainlandDrivingPermitNo_plh'
                      )
                    "
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col v-if="isGHCompany" :xs="24" :sm="12">
                <el-form-item
                  :label="$t('hzmbChange.label.drvLicNoHk', [numLetter(index)])"
                  prop="drvLicNoHk"
                >
                  <el-input
                    v-model="form.drivers[index].drvLicNoHk"
                    :placeholder="$t('hzmbChange.message.drvLicNoHk')"
                    @input="
                      form.drivers[index].drvLicNoHk = $event.replace(/\s/g, '')
                    "
                  ></el-input>
                </el-form-item>
              </el-col>
              <template v-if="isE02F02">
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="
                      $t('hzmbChange.label.drvTempLicNoCn', [numLetter(index)])
                    "
                    prop="drvTempLicNoCn"
                  >
                    <el-input
                      v-model="form.drivers[index].drvTempLicNoCn"
                      :placeholder="
                        $t(
                          'message.DataRegistration.Driver.mainlandDrivingPermitNo_plh'
                        )
                      "
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="
                      $t('hzmbChange.label.drvTempLicNoCnStartDate', [
                        numLetter(index),
                      ])
                    "
                    prop="drvTempLicNoCnStartDate"
                  >
                    <el-date-picker
                      v-model="form.drivers[index].drvTempLicNoCnStartDate"
                      type="date"
                      :placeholder="
                        $t('hzmbChange.message.drvTempLicNoCnStartDate')
                      "
                      format="dd/MM/yyyy"
                      value-format="yyyy-MM-dd"
                      :picker-options="{
                        disabledDate: (time) => {
                          const endDate = form.drivers[index].drvTempLicNoCnEndDate;
                          if (endDate) {
                            return time.getTime() > new Date(endDate).getTime();
                          }
                        },
                      }"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12">
                  <el-form-item
                    :label="
                      $t('hzmbChange.label.drvTempLicNoCnEndDate', [
                        numLetter(index),
                      ])
                    "
                    prop="drvTempLicNoCnEndDate"
                  >
                    <el-date-picker
                      v-model="form.drivers[index].drvTempLicNoCnEndDate"
                      type="date"
                      :placeholder="
                        $t('hzmbChange.message.drvTempLicNoCnEndDate')
                      "
                      format="dd/MM/yyyy"
                      value-format="yyyy-MM-dd"
                      :picker-options="{
                        disabledDate: (time) => {
                          const startDate =
                            form.drivers[index].drvTempLicNoCnStartDate || null;
                          const date = new Date();
                          let myDate =
                            startDate && new Date(startDate) > date
                              ? new Date(startDate)
                              : date;
                          return (
                            time.getTime() <
                            myDate.getTime() - 1 * 24 * 60 * 60 * 1000
                          );
                        },
                      }"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </template>
            </el-row>
          </el-form>
        </FormCard>
      </div>
      <div class="add_driver">
        <GradientBtn :disabled="form.drivers.length == 3" @click="addCard">{{
          $t("hzmbChange.action.add_drivers")
        }}</GradientBtn>
      </div>
    </FormBox>

    <!-- 澳門地址彈窗 -->
    <MacauAddressDialog
      :visible="showAddressDialog"
      @save="saveMacauAddress"
      @close="showAddressDialog = false"
    ></MacauAddressDialog>
  </div>
</template>

<script>
import i18n from "/public/lang/index";
import FormBox from "../../../components/FormBox.vue";
import FormCard from "../../../components/FormCard.vue";
import VssViewAPI from "@/api/VssViewAPI";
import GradientBtn from "@/components/GradientBtn.vue";
import MacauAddressDialog from "../../../components/MacauAddressDialog.vue";
import { isAfterYears } from "@/util/util";
export default {
  props: {
    form: {
      type: Object,
      default: () => {
        return {
          drivers: [{}],
        };
      },
    },
    applicantType: String,
  },
  components: { FormBox, FormCard, MacauAddressDialog, GradientBtn },
  data() {
    let validcodeMacauMobile = (rule, value, callback) => {
      let reg = /[6]{1}[0-9]{7}/;
      if (value && !reg.test(value)) {
        callback(new Error(i18n.t("hzmbChange.message.macauMobile")));
      } else {
        callback();
      }
    };
    let olderThan18 = (rule, value, callback) => {
      const birthdays = new Date(value) || value;
      let d = new Date();
      let age = null;
      if (birthdays) {
        age =
          d.getFullYear() -
          birthdays.getFullYear() -
          (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
            ? 1
            : 0);
      }
      if (value && age < 18) {
        callback(new Error(i18n.t("hzmbChange.message.mustAdult")));
      } else {
        callback();
      }
    };
    let macauDrivingLicenseCheck = (rule, value, callback) => {
      // console.log(rule);
      // 通過是否有重複項判斷是否重複
      const isRepeat = (arr) => {
        var hash = {};
        for (var i in arr) {
          if (hash[arr[i]]) {
            return true;
          }
          hash[arr[i]] = true;
        }
        return false;
      };

      if (value) {
        var drivers = this.form.drivers.map((item) => {
          return item.drvLicTypeMo && item.drvLicNoMo
            ? item.drvLicTypeMo + item.drvLicNoMo
            : null;
        });
        if (isRepeat(drivers)) {
          callback(
            new Error(i18n.t("hzmbChange.message.macauDrivingLicenseCheck"))
          );
        } else {
          for (let i in this.$refs["ruleForm"]) {
            let _field = this.$refs["ruleForm"][i].fields;
            // console.log(this.$refs["ruleForm"][i].fields);
            _field.map((i) => {
              if (i.prop === "drvLicNoMo" || i.prop === "drvLicTypeMo") {
                i.clearValidate();
                return false;
              }
            });
          }
          callback();
        }
      }
    };
    let mainlandPhoneCheck = (rule, value, callback) => {
      // 驗證內地聯絡電話
      for (let i in this.form.drivers) {
        let mainlandPhone = this.form.drivers[i].mainlandPhone;
        let mainlandEmail = this.form.drivers[i].mainlandEmail;
        if (value == mainlandPhone && !mainlandEmail) {
          this.driversRules.mainlandPhone[0].required = true;
          this.driversRules.mainlandEmail[0].required = false;
        }
        if (value == mainlandPhone && !value && !mainlandEmail) {
          this.driversRules.mainlandPhone[0].required = true;
          this.driversRules.mainlandEmail[0].required = true;
          callback(new Error(""));
        } else {
          callback();
        }
      }
    };
    let mainlandEmailCheck = (rule, value, callback) => {
      //验证邮箱地址
      const patt = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
      if (value && !patt.test(value)) {
        callback(new Error(i18n.t("hzmbChange.message.emailCheck")));
        return;
      }
      for (let i in this.form.drivers) {
        let mainlandPhone = this.form.drivers[i].mainlandPhone;
        let mainlandEmail = this.form.drivers[i].mainlandEmail;
        if (value == mainlandEmail && !mainlandPhone) {
          this.driversRules.mainlandPhone[0].required = false;
          this.driversRules.mainlandEmail[0].required = true;
        }
        if (value == mainlandEmail && !value && !mainlandPhone) {
          this.driversRules.mainlandPhone[0].required = true;
          this.driversRules.mainlandEmail[0].required = true;
          callback(new Error(""));
        } else {
          callback();
        }
      }
    };
    return {
      loading: false,
      serviceType: this.$route.params.serviceType,
      beforeToday: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天
        },
      },
      olderThan18: {
        disabledDate(time) {
          const older18 = new Date().setYear(new Date().getFullYear() - 18);
          return time.getTime() > older18;
        },
      },
      driversRules: {
        drvCname: [
          {
            max: 200,
            message: i18n.t("hzmbChange.message.maxLength", [200]),
            trigger: "blur",
          },
          {
            pattern: /^[\u4e00-\u9fa5\s]*$/,
            message: i18n.t("hzmbChange.message.onlyChinese"),
          },
        ],
        drvEname: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
            trigger: "blur",
          },
          {
            max: 200,
            message: i18n.t("hzmbChange.message.maxLength", [200]),
            trigger: "blur",
          },
        ],
        drvIdentNo: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
            trigger: "blur",
          },
          {
            max: 20,
            message: i18n.t("hzmbChange.message.maxLength", [20]),
            trigger: "blur",
          },
        ],
        drvGender: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
          },
        ],
        drvBirthDate: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.dateRequired"),
            trigger: "blur",
          },
          { validator: olderThan18, trigger: "change" },
          { validator: olderThan18, trigger: "blur" },
        ],
        drvNational: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
            trigger: "change",
          },
        ],
        otherNationalityText: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
          },
        ],
        drvLicTypeMo: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
          },
          { validator: macauDrivingLicenseCheck, trigger: "submit" },
        ],
        drvLicNoMo: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
            trigger: "blur",
          },
          {
            max: 20,
            message: i18n.t("hzmbChange.message.maxLength", [20]),
            trigger: "blur",
          },
          { validator: macauDrivingLicenseCheck, trigger: "submit" },
        ],
        mainlandEmail: [
          {
            required: true,
            message: i18n.t(" "),
          },
          {
            max: 50,
            message: i18n.t("hzmbChange.message.maxLength", [50]),
            trigger: "blur",
          },
          { validator: mainlandEmailCheck },
        ],
        drvMobile: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
            trigger: "blur",
          },
          { validator: validcodeMacauMobile, trigger: "blur" },
          {
            max: 30,
            message: i18n.t("hzmbChange.message.maxLength", [30]),
            trigger: "blur",
          },
        ],
        drvAddress1: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
            trigger: "blur",
          },
          {
            pattern: /^.{5,}$/,
            message: i18n.t("hzmbChange.message.addressMin"),
          },
        ],
        mainlandPhone: [
          {
            required: true,
            message: i18n.t(" "),
          },
          {
            pattern: /^[\d]+$/,
            message: i18n.t("hzmbChange.message.mainlandPhoneCheck"),
            trigger: "blur",
          },
          { validator: mainlandPhoneCheck },
        ],
        drvLicNoHk: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
          },
          {
            max: 20,
            message: i18n.t("hzmbChange.message.maxLength", [20]),
            trigger: "blur",
          },
        ],
        drvTempLicNoCn: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
          },
          {
            max: 100,
            message: i18n.t("hzmbChange.message.maxLength", [100]),
            trigger: "blur",
          },
        ],
        drvTempLicNoCnStartDate: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
          },
        ],
        drvTempLicNoCnEndDate: [
          {
            required: true,
            message: i18n.t("hzmbChange.message.notNull"),
          },
        ],
      },
      sex: [],
      nationality: [],
      drivingLicenseType: [],
      locked: null,
      setDriver: "",
      setDriverOld: null,
      timer: "",
      showAddressDialog: false,
      macauAddressIndex: -1,
      areas: [
        { value: "853", text: i18n.t("hzmbChange.enum.areas.macau") },
        { value: "852", text: i18n.t("hzmbChange.enum.areas.hongkong") },
      ],
    };
  },
  watch: {
    "form.quota": {
      handler() {
        clearTimeout(this.timer);
        if (this.locked) {
          this.timer = setTimeout(() => {
            this.setDrivers(this.locked, true);
          }, 1000);
        }
      },
      immediate: true,
      deep: true,
    },
    quotaPersonAge(val) {
      if (val < 70) {
        this.locked = 1;
        this.setDrivers(1, true);
      }
    },
    setDriver(newVal, oldVal) {
      this.setDriverOld = oldVal;
      this.form.quotaInfoToDri = newVal !== 0;
    },
  },
  computed: {
    driversNum() {
      return function (index, showDe = true) {
        if (showDe) {
          return (
            this.$t("message.DataRegistration.formData.no") +
            this.$t(`message.capitalLetter[${index + 1}]`) +
            this.$t("message.DataRegistration.formData.driver_de")
          );
        } else {
          return this.$t("hzmbChange.label.drivers_no", [
            this.$t(`message.capitalLetter[${index + 1}]`),
          ]);
        }
      };
    },
    numLetter() {
      return (index) => {
        return this.$t(`message.capitalLetter[${index + 1}]`);
      };
    },
    quotaPersonAge() {
      const birthday = this.form.quota.birthday;
      const birthdays = new Date(birthday);
      let d = new Date();
      let age = null;
      if (birthday) {
        age =
          d.getFullYear() -
          birthdays.getFullYear() -
          (d.getMonth() < birthdays.getMonth() ||
          (d.getMonth() == birthdays.getMonth() &&
            d.getDate() < birthdays.getDate())
            ? 1
            : 0);
      }
      return age;
    },
    lan() {
      return this.$i18n.locale;
    },
    isGHCompany() {
      return this.serviceType === "HZMB_GH_CHANGE_COMP";
    },
    isE02F02() {
      const { hzmbSubtype } = this.form;
      return this.isGHCompany && ["E02", "F02"].includes(hzmbSubtype);
    },
    isE01E03() {
      const { hzmbSubtype } = this.form;
      return this.isGHCompany && ["E01", "E03"].includes(hzmbSubtype);
    },
  },
  methods: {
    isAfterYears,
    //   删除卡片式表单
    closeCard(index) {
      let drivers = this.form.drivers;
      delete drivers[index];
      this.form.drivers = drivers.filter((item) => item);
    },
    //   增加卡片式表单
    addCard() {
      this.form.drivers.push({
        mobileAreaCode: this.isE02F02 ? "853" : null,
      });
    },

    // 子組件校驗，傳到父組件
    validateForm() {
      let flag = true;
      if (this.form.drivers.length < 1) return true;
      delete this.driversRules.drvLicTypeMo[1].trigger;
      delete this.driversRules.drvLicNoMo[2].trigger;
      for (let i = 0; i < this.form.drivers.length; i++) {
        let drivers = this.form.drivers;
        console.log(
          drivers.filter((item) => !item.mainlandPhone && !item.mainlandEmail)
        );
        if (
          drivers.filter((item) => item.mainlandPhone || item.mainlandEmail)
            .length == drivers.length
        ) {
          this.driversRules.mainlandEmail[0].required = false;
          this.driversRules.mainlandPhone[0].required = false;
        }
        this.$refs["ruleForm"][i].validate((valid) => {
          if (!valid) flag = false;
        });
      }
      return flag;
    },

    // 應用車主信息
    setDrivers(index, watch = false, first = false) {
      // 填入車主資料到選擇的駕駛人中
      const inputDrivers = (index, input) => {
        const form = this.form;
        const quota = form.quota;
        let driver = {};
        driver.drvCname = input ? quota.applicantCname || null : null;
        driver.drvEname = input ? quota.applicantEname || null : null;
        driver.drvIdentNo = input ? quota.applicantIdentNo || null : null;
        driver.drvBirthDate = input ? quota.birthday || null : null;
        driver.drvAddress1 =
          input && quota.macauAddress && quota.macauAddress.textCn
            ? quota.macauAddress.textCn
            : "";
        driver.drvMobile = input ? quota.applicantMobile || null : null;
        driver.mainlandPhone = input ? quota.mainlandPhone || null : null;
        driver.mainlandEmail = input ? quota.mainlandEmail || null : null;
        form.drivers[index] = { ...form.drivers[index], ...driver };
        this.$set(this.form.drivers, 0, {
          ...this.form.drivers[index],
          ...driver,
        });
        // 處理nameEn驗證異步
        if (form.quota.applicantEname) {
          const _fields = this.locked
            ? this.$refs["ruleForm"][this.locked - 1].fields
            : null;
          // console.log(_fields);
          if (_fields) {
            _fields.map((i) => {
              if (i.prop === "drvEname") {
                i.resetField();
                return false;
              }
            });
          }
        }
      };
      // 切換到無
      if (index == 0 && !first) {
        this.$confirm(
          `${this.$t("hzmbChange.message.change_drivers_tips", [
            this.$t(`message.capitalLetter[${this.locked}]`),
          ])}`,
          this.$t("message.tips"),
          {
            confirmButtonText: this.$t("message.confirm"),
            cancelButtonText: this.$t("message.cancel"),
            type: "warning",
          }
        )
          .then(() => {
            const form = this.form;
            this.$set(this.form.drivers, this.locked - 1, {});
            this.$store.commit("updateForm", form);
            this.$refs["ruleForm"][this.locked - 1].resetFields();
            this.locked = index;
          })
          .catch(() => {
            this.setDriver = this.setDriverOld;
            this.locked = this.setDriverOld;
          });
        return false;
      }
      if (watch) {
        inputDrivers(index - 1, true);
        return;
      } else {
        if (this.locked && index >= 0) {
          // 刪除上一個駕駛人資料
          this.$confirm(
            `${this.$t("hzmbChange.message.change_drivers_tips", [
              this.$t(`message.capitalLetter[${this.locked}]`),
            ])}`,
            this.$t("message.tips"),
            {
              confirmButtonText: this.$t("message.confirm"),
              cancelButtonText: this.$t("message.cancel"),
              type: "warning",
            }
          )
            .then(() => {
              // 駕駛人資料互換後，清空上一個表單
              let drivers = this.form.drivers;
              this.form.drivers[index - 1] = drivers[this.locked - 1];
              this.form.drivers[this.locked - 1] = {};
              // 將車主信息資料應用到駕駛人
              inputDrivers(index - 1, true);
              inputDrivers(this.locked - 1, false);
              this.$refs["ruleForm"][this.locked - 1].resetFields();
              this.locked = index;
            })
            .catch(() => {
              this.setDriver = this.setDriverOld;
            });
        } else {
          if (!first) {
            this.$confirm(
              `${this.$t("hzmbChange.message.change_drivers_tips", [
                this.$t(`message.capitalLetter[${this.locked || 1}]`),
              ])}`,
              this.$t("message.tips"),
              {
                confirmButtonText: this.$t("message.confirm"),
                cancelButtonText: this.$t("message.cancel"),
                type: "warning",
              }
            )
              .then(() => {
                inputDrivers(index - 1, true);
                this.locked = index;
              })
              .catch(() => {
                this.setDriver = this.setDriverOld;
                this.locked = this.setDriverOld;
              });
          } else {
            inputDrivers(index - 1, true);
            this.locked = index;
          }
        }
      }
    },
    quotaChange(index) {
      this.setDrivers(index);
    },
    // 打開澳門地址填寫彈窗
    onAddressFocus(index) {
      this.macauAddressIndex = index;
      this.showAddressDialog = true;
    },
    // 儲存澳門地址回調
    saveMacauAddress(val) {
      this.showAddressDialog = false;
      const { textCn } = val;
      this.$set(
        this.form.drivers[this.macauAddressIndex],
        "drvAddress1",
        textCn
      );
    },
    // 修改國籍
    changeNationality(val, index) {
      this.form.drivers[index].otherNationality = val === "XXX";
    },
    // 輸入字母轉大寫
    inputToUpperCase(val, index, name) {
      this.form.drivers[index][name] = val.toUpperCase();
    },
  },
  async created() {
    // 獲取基礎數據
    try {
      this.loading = true;
      this.nationality = await VssViewAPI.getNationalitys();
      const drivingLicenseType = await VssViewAPI.getDrivingLicenseTypes();
      if (this.isGHCompany && this.form.hzmbSubtype === "F02") {
        this.drivingLicenseType = drivingLicenseType.filter(
          (e) => e.codeKey !== "6"
        );
      } else {
        this.drivingLicenseType = drivingLicenseType.filter(
          (e) => this.isGHCompany || e.codeKey !== "7"
        );
      }
      this.sex = await VssViewAPI.getsexs();
    } catch (error) {
      this.$error(error);
    } finally {
      this.loading = false;
    }
    // 默認添加1名駕駛員
    if (this.applicantType === "PERSON") {
      // 是否將配額人資料自動填入駕駛員資料回顯
      if (this.form.quotaInfoToDri || this.form.quotaInfoToDri === null) {
        this.setDriver = 1;
        this.setDrivers(this.setDriver, false, true);
      } else {
        this.setDriver = 0;
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.input_choose_title {
  margin: 16px 0;
  font-size: 18px;
}
.input_choose_btns {
  /deep/.el-radio {
    background: #fff;
    margin-right: 10px;
  }
}
.add_driver {
  margin-top: 24px;
  text-align: right;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.m-mobile_row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  .el-select {
    width: 200px;
    margin-right: 8px;
  }
}
</style>